import React, { useContext } from "react";

import { observer } from "mobx-react";

import ComponentContext from "../../../contexts/ComponentContext";
import ButtonJobAlert from "./ButtonJobAlert";
import SimpleJobAlert from "./SimpleJobAlert";
import StackedJobAlert from "./StackedJobAlert";
import StandardJobAlert from "./StandardJobAlert";

function JobAlert() {
  const { type } = useContext(ComponentContext);

  switch (type) {
    case "simple":
      return <SimpleJobAlert />;
    case "stacked":
      return <StackedJobAlert />;
    case "button":
      return <ButtonJobAlert />;
    default:
      return <StandardJobAlert />;
  }
}

export default observer(JobAlert);
